var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tags),function(item){return _c('el-tag',{key:item,staticStyle:{"margin-right":"10px"},attrs:{"type":item,"effect":"info"}},[_vm._v(" "+_vm._s(item)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }